import Axios, { AxiosResponse } from 'axios';
import { useCallback, useState } from 'react';

import AuthService from '../utils/AuthService';

const REACT_APP_API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT!;

/**
 * 「あずけるボックス」サービスの状態
 *
 * @returns canceled: キャンセル済
 * @returns delivered: 配達完了
 * @returns collected: 集荷完了
 * @returns expireCanceled: 有効期限切れ
 * @returns reserved: 予約完了
 */
export type DeliveryboxShareStatus =
  | 'canceled'
  | 'delivered'
  | 'collected'
  | 'reserved'
  | 'expireCanceled'
  | 'unknown';

export interface DeliveryBoxShare {
  deliveryBoxShareId: string;
  deviceId: string;
  userId: string;
  status: DeliveryboxShareStatus;
  destination: string;
  expireDate: string;
  updateDate: string;
  createDate: string;
}

export const useListDeliveryBoxShare = (): {
  getData: (deviceId?: string, limit?: number) => Promise<void>;
  data: DeliveryBoxShare[];
  isCompleted: boolean;
  isLoading: boolean;
  isError: boolean;
} => {
  const [data, setData] = useState<DeliveryBoxShare[]>([]);
  const [isCompleted, setIsCompleted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const getData = useCallback(async (deviceId?: string, limit = 30) => {
    setIsCompleted(false);
    setIsLoading(true);
    setIsError(false);

    try {
      const idToken = AuthService.getIdToken();

      const response: AxiosResponse<{ deliveryBoxShares: DeliveryBoxShare[] }> =
        await Axios.get(`${REACT_APP_API_ENDPOINT}/shares`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          },
          params: {
            deviceId,
            limit,
          },
        });

      setData(response.data.deliveryBoxShares);
      setIsCompleted(true);
    } catch (e) {
      setIsError(true);
    }

    setIsLoading(false);
  }, []);

  return { getData, data, isCompleted, isLoading, isError };
};
